import React from "react";

export type ColumnDef<T> = {
  header: string;
  render: (row: T) => React.ReactNode;
  span?: number;
  className?: string;
};

export type GenericGroupTableProps<T> = {
  columns: Array<ColumnDef<T>>;
  items: Array<T & { id: string }>;
};

export function GroupTable<T>({ columns, items }: GenericGroupTableProps<T>) {
  const template = {
    gridTemplateColumns: `repeat(${columns.length}, minmax(0, 1fr))`,
  } as React.CSSProperties;

  return (
    <div className="cx-bg-white cx-rounded-lg cx-shadow-sm cx-border cx-border-neutral-light cx-mt-3">
      <div className="cx-px-6 cx-py-3">
        <div
          className="cx-grid cx-gap-4 cx-text-text-secondary cx-text-sm cx-font-medium cx-py-3"
          style={template}
        >
          {columns.map((c, idx) => (
            <div
              key={`header-${idx}`}
              className={`cx-truncate ${c.className || ""}`}
            >
              {c.header}
            </div>
          ))}
        </div>
        <div className="cx-border-b cx-border-heavy cx-my-0" />
        <div className="cx-divide-y cx-divide-neutral-light">
          {items.map((row: any) => (
            <div
              key={row.id}
              className="cx-flex cx-items-center cx-justify-between cx-py-5"
            >
              <div className="cx-grid cx-gap-4 cx-flex-1" style={template}>
                {columns.map((c, idx) => (
                  <div
                    key={`cell-${row.id}-${idx}`}
                    className={`cx-text-text-primary ${c.className || ""}`}
                  >
                    {c.render(row)}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default GroupTable;
